import React, { Fragment } from "react"
import AvailableActions from "../../../actions/AvailableActions"
import { Dropdown, Button, Input } from "ui"

const PAGE_REDIRECT_ACTION = "page.action.redirect"

const BlockAction = props => {
    return (
        <AvailableActions>
            {actions => {
                const options = actions.map(property => ({
                    value: property.id,
                    label: property.name,
                }))
                // Allow page specific actions
                options.push({
                    value: PAGE_REDIRECT_ACTION,
                    label: "Navigate to a different page",
                })
                return (
                    <Fragment>
                        <Dropdown
                            {...props}
                            options={options}
                            onChange={value => props.onChange({ ...props.action, type: value })}
                            value={props.action.type}
                        />
                        {props.action.type == PAGE_REDIRECT_ACTION && (
                            <Input
                                value={props.action.location}
                                onChange={event =>
                                    props.onChange({
                                        ...props.action,
                                        location: event.target.value,
                                    })
                                }
                            />
                        )}

                        <Button onClick={props.remove} icon="times" />
                    </Fragment>
                )
            }}
        </AvailableActions>
    )
}

export default BlockAction



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/actions/BlockAction.js